import type { DeviceManager } from '@yandex-360/telemost-sdk/device-manager';
import { all, call, fork, put, select } from 'typed-redux-saga';

import { ChannelHolder } from '../../helpers/channelHolder';
import { createLogger } from '../../helpers/loggerFacade';
import { selectInitSessionConfig } from '../goloom-sdk/selectors';
import { selectNoiseCancellationType } from '../settings';
import { waitForSettingsLoaded } from '../settings/sagas';
import { buildGoloomInitConfig } from './adapters/goloom';
import { deviceManager } from './instance';
import { resetDeviceError, ResetDeviceErrorPayload, setDeviceError, SetDeviceErrorPayload } from './slice';

const logger = createLogger('goloom:device-manager:sagas');

export function* setDeviceManagerErrorSaga(payload: SetDeviceErrorPayload) {
    yield* put(setDeviceError(payload));
}

export function* resetDeviceManagerErrorSaga(payload: ResetDeviceErrorPayload) {
    yield* put(resetDeviceError(payload));
}

export function* waitForDeviceManagerInit() {
    if (deviceManager.isPreviewInitialized()) {
        return;
    }

    const channelHolder = new ChannelHolder();
    try {
        return yield* channelHolder.take(deviceManager.onInit);
    } finally {
        channelHolder.close();
    }
}

function* initDeviceManagerSaga(this: DeviceManager) {
    if (this.isPreviewInitialized()) {
        return;
    }

    yield* call(waitForSettingsLoaded, 'initDeviceManagerSaga', logger);

    const config = yield* select(selectInitSessionConfig);
    const noiseCancellationType = yield* select(selectNoiseCancellationType);

    this.init({
        config: buildGoloomInitConfig(config),
        noiseCancellationType,
    });
}

export function* rootDeviceManager() {
    const channelHolder = new ChannelHolder();

    try {
        yield all([
            fork([deviceManager, initDeviceManagerSaga]),
            channelHolder.takeEvery(deviceManager.onError, setDeviceManagerErrorSaga),
            channelHolder.takeEvery(deviceManager.onResetError, resetDeviceManagerErrorSaga),
        ]);
    } finally {
        channelHolder.close();
    }
}
